import { Box, CircularProgress } from '@mui/material';

const Loader = () => (
  <Box
    sx={{ minHeight: '100px' }}
    className="w-100 h-100 d-flex justify-content-center align-items-center"
  >
    <CircularProgress />
  </Box>
);

export default Loader